import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ExpandableCard } from '@shared';

@Component({
	selector: 'app-sample-card',
	templateUrl: './sample-card.component.html',
	styleUrls: ['./sample-card.component.scss']
})
export class SampleCardComponent {
	@Input() public cardData: ExpandableCard;
	@Input() public rowLimit: number;
	@Input() public isReadonlyMode: boolean;
	@Output() public selectedCard: EventEmitter<number> = new EventEmitter();
	@Output() public createDupAction: EventEmitter<number> = new EventEmitter();
	@Output() public deleteRecordAction: EventEmitter<number> = new EventEmitter();

	public selectCard(): void {
		this.selectedCard.emit(this.cardData.id);
	}

	public createDup(e: any): void {
		e.stopPropagation();
		this.createDupAction.emit(this.cardData.id);
	}

	public deleteRecord(e: MouseEvent): void {
		e.stopPropagation();
		this.deleteRecordAction.emit(this.cardData.id);
	}
}
